export interface IApiError {
    errorCode: number;
}

export interface ISerializable<T> {
    fromJson(json: any, ...params: string[]): T;
}

export class ApiError implements ISerializable<ApiError> {
    public message: string;
    public errorCode: number

    constructor(message: string, errorCode: number) {
        this.message = message;
        this.errorCode = errorCode;
    }


    public fromJson(json:any): ApiError {
        this.message = json.message;
        this.errorCode = json.errorCode;

        return this;
    }
}




// WEBPACK FOOTER //
// ./src/api/errors/types.ts